import { Logger } from 'ui-common/src';
import { setJitaEnabledAccount } from 'ui-common/src/utils/LoginActions';
import { removeMenuById, removeMenuByIds } from '../utils/removeMenuByID/removeMenuByID';

export const SIDE_MENU_LOADING = 'SIDE_MENU_LOADING';
export const SIDE_MENU_LOADED = 'SIDE_MENU_LOADED';
export const UPDATE_MENU_FILTER = 'UPDATE_MENU_FILTER';

const sideMenuLoading = () => ({ type: SIDE_MENU_LOADING, loading: true });

const InitializeSideMenu = (featureFlags, leftMenuData) => (dispatch, getState) => {
  dispatch(sideMenuLoading());

  const MENU_TO_ALLOW_IF_PAM_DISABLED = [
    'new-privileged-access',
    'privileged-sessions',
    'past-sessions',
  ];
  const { isPamGen2, isEmergencyRolesUser, isIntegration } = featureFlags;

  Logger.info(leftMenuData);

  if (leftMenuData && leftMenuData.length > 0) {
    let sideMenu = [
      ...leftMenuData.filter((menu) => menu.id !== (isIntegration ? 'design' : 'integrations')),
    ];
    Logger.info(sideMenu);

    if (isPamGen2) {
      sideMenu = removeMenuByIds(sideMenu, MENU_TO_ALLOW_IF_PAM_DISABLED);
    }
    if (!isEmergencyRolesUser) {
      sideMenu = removeMenuById(sideMenu, 'request-emergency-access-roles');
    }

    Logger.info(sideMenu);

    // Derive isJitaEnabled from the backend left nav response.
    // If the response contains 'jita-sessions' or 'jit-access', the user is a JITA user.
    const hasJitaNavItem = sideMenu.some(
      (menu) =>
        menu.id === 'jit-access' ||
        menu.subMenu?.some((sub) => sub.id === 'jita-sessions')
    );
    dispatch(setJitaEnabledAccount(hasJitaNavItem));

    dispatch({
      type: SIDE_MENU_LOADED,
      data: sideMenu,
    });
  }
};

const updateMenuFilter = (menuId, isEnabled) => (dispatch, getState) => {
  const state = getState();
  const currentFilter = state.app?.menuFilters?.[menuId];
  const rawSideMenu = state.app?.rawSideMenu;
  
  // Only update if conditions are met
  if (rawSideMenu?.length && currentFilter !== isEnabled) {
    dispatch({
      type: UPDATE_MENU_FILTER,
      menuId,
      isEnabled
    });
  }
};

export { InitializeSideMenu, updateMenuFilter };
